import isNil from 'lodash/isNil'
import uniq from 'lodash/uniq'
import { calculateDecimals, calculatePrecision } from 'utils'

import { InstrumentActionType } from './actions'
import * as AT from './actionTypes'
import { CurrencyDefinitionType, InstrumentType, SymbolType } from './types'

export type InstrumentStateType = {
  readonly all: InstrumentType[]
  readonly currencies: CurrencyDefinitionType[]
  readonly favorites: SymbolType[]
  readonly previousSymbol: SymbolType
  readonly symbol: SymbolType
}

const initialState = {
  all: [],
  currencies: [],
  favorites: [],
  previousSymbol: '',
  symbol: ''
}

const parseInstrument = (instrument: InstrumentType): InstrumentType => {
  return {
    ...instrument,
    min_order_size_calc: calculatePrecision(
      instrument.min_order_size,
      instrument.min_order_size_scale
    ),
    price_increment: calculateDecimals(
      instrument.min_price_increment,
      instrument.min_price_increment_scale
    ),
    volume_increment: calculateDecimals(instrument.lot_size, instrument.lot_size_scale)
  }
}

const instrument = (
  state: InstrumentStateType = initialState,
  action: InstrumentActionType
): InstrumentStateType => {
  switch (action.type) {
    case AT.ADD_FAVORITE: {
      return {
        ...state,
        favorites: uniq([...state.favorites, action.payload.symbol])
      }
    }
    case AT.REMOVE_FAVORITE: {
      if (state.favorites.length > 0 && state.favorites.includes(action.payload.symbol)) {
        const filtered = state.favorites.filter((favorite) => favorite !== action.payload.symbol)
        const favorites = filtered.length === 0 ? initialState.favorites : filtered

        return {
          ...state,
          favorites
        }
      }

      return state
    }

    case AT.SET_ALL: {
      return {
        ...state,
        all: action.payload.instruments.map(parseInstrument)
      }
    }

    case AT.SET_CURRENCIES: {
      return {
        ...state,
        currencies: action.payload.currencies
      }
    }

    case AT.SET_SYMBOL: {
      if (action.payload.symbol === state.symbol) {
        return state
      }

      return {
        ...state,
        previousSymbol: state.symbol,
        symbol: action.payload.symbol
      }
    }

    case AT.SET_FAVORITES: {
      const { favorites } = action.payload
      if (isNil(favorites) || favorites.length === 0) {
        return state
      }

      return {
        ...state,
        favorites
      }
    }

    case AT.SET_UPDATE: {
      return {
        ...state,
        all: [
          ...state.all.filter((i) => i.symbol !== action.payload.instrument.symbol),
          parseInstrument(action.payload.instrument)
        ]
      }
    }

    default:
      return state
  }
}

export default instrument
